import "core-js/modules/es6.function.name";
import dstyled from 'astroturf';
import React from 'react';
import Heading from './Heading';
import List from './List';
import DocBlock from './TsDocBlock';
import TitleSignature from './TsDocTitleSignature';
import TsDocTypeExpression from './TsDocTypeExpression';
import { getLinkedNode, getPropertyKey, isObjecty, propertyEntries } from './utils/tsDocTypeExpression';
var DocListItem = /*#__PURE__*/dstyled('li', null, {
  displayName: "DocListItem",
  styles: require("./TsDocMembers-DocListItem.module.css"),
  attrs: null,
  vars: []
});

var typeParamsWithComment = function typeParamsWithComment(params) {
  return params === null || params === void 0 ? void 0 : params.filter(function (p) {
    return p.description;
  });
};

function TsDocMembers(_ref) {
  var _getLinkedNode, _definition$parameter, _typeDef$typedocs;

  var definition = _ref.definition,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth,
      hideProperties = _ref.hideProperties;
  var typeDef = (_getLinkedNode = getLinkedNode(definition)) !== null && _getLinkedNode !== void 0 ? _getLinkedNode : definition;
  var typeParams = typeParamsWithComment(definition.typeParameter);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!(typeParams === null || typeParams === void 0 ? void 0 : typeParams.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: depth
  }, "Type Parameters"), /*#__PURE__*/React.createElement(List, null, definition.typeParameter.map(function (param) {
    return /*#__PURE__*/React.createElement(DocListItem, {
      key: param.name
    }, /*#__PURE__*/React.createElement(TitleSignature, {
      definition: param
    }), /*#__PURE__*/React.createElement(DocBlock, {
      definition: param,
      depth: depth + 1,
      hideReturns: true
    }));
  }))), !!((_definition$parameter = definition.parameters) === null || _definition$parameter === void 0 ? void 0 : _definition$parameter.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: depth
  }, "Parameters"), /*#__PURE__*/React.createElement(List, null, definition.parameters.map(function (param) {
    return /*#__PURE__*/React.createElement(DocListItem, {
      key: param.name
    }, /*#__PURE__*/React.createElement(TitleSignature, {
      definition: param
    }), /*#__PURE__*/React.createElement(DocBlock, {
      definition: param,
      depth: depth + 1,
      hideReturns: true
    }));
  }))), !hideProperties && !!((_typeDef$typedocs = typeDef.typedocs) === null || _typeDef$typedocs === void 0 ? void 0 : _typeDef$typedocs.length) && isObjecty(typeDef) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: depth
  }, /*#__PURE__*/React.createElement(TsDocTypeExpression, {
    type: typeDef,
    compact: true
  })), /*#__PURE__*/React.createElement(List, null, propertyEntries(typeDef.typedocs).map(function (_ref2) {
    var keyNode = _ref2[0],
        valueNode = _ref2[1];
    return /*#__PURE__*/React.createElement(DocListItem, {
      key: valueNode.name
    }, /*#__PURE__*/React.createElement(TitleSignature, {
      title: /*#__PURE__*/React.createElement("code", null, getPropertyKey(keyNode)),
      definition: valueNode
    }), /*#__PURE__*/React.createElement(DocBlock, {
      definition: valueNode,
      depth: depth + 1,
      hideReturns: true
    }));
  }))));
}

export default TsDocMembers;